<template>
  <div
    @click="$data.$_ssSDV_showPicker = false"
  >
    <!-- Header -->
    <div class="ss-dashboard-header">
      <div class="ss-dashboard-header__content">
        <div
          class="ss-dashboard-header__graphic"
          @click="$router.push({
            name: 'Profile.mine'
          }).catch(() => {})"
        >
          <oct-media
            :image="me.profileIcon"
            :alt="`${me.lastName} ${me.firstName}`"
            class="ss-dashboard-header__image"
          />
        </div>

        <!-- Title -->
        <div class="ss-dashboard-header__title">
          <span class="ss-dashboard-header__title-text">
            {{ $_octPrototypeView_getDateString(new Date) }}
          </span>
        </div>

        <!-- Actions -->
        <div
          class="ss-dashboard-header__actions"
          v-if="me.data.verified !== false"
        >
          <!-- Comments -->
          <div
            class="ss-dashboard-header__action"
            @click="$router.push({
              name: 'Comments.mine'
            })"
          >
            <oct-icon icon="message-outline" />
          </div>

          <!-- Notifications -->
          <div
            class="ss-dashboard-header__action"
            :class="{
              'ss-dashboard-header__action--activated': !isNotificationRead
            }"
            @click="$router.push({
              name: 'Notifications'
            })"
          >
            <oct-icon icon="bel-outline" v-if="isNotificationRead" />
            <oct-icon icon="bel" v-else />
          </div>

          <div class="ss-dashboard-header__action ss-dashboard-header__action--exit">
            <oct-icon icon="exit" @click.native="signOut" />
          </div>
        </div>
      </div>
    </div>

    <div class="ss-salon-dashboard-view__tabs">
      <oct-tabs
        :items="$data.$_ssSDV_tabs"
        @click:item="onClickTab"
      />
    </div>

    <div class="ss-salon-dashboard-view__content">
      <div class="ss-salon-dashboard-view-header">
        <h1 class="ss-salon-dashboard-view-header__title">
          {{ $route.meta.title }}
        </h1>

        <div
          class="ss-salon-dashboard-view-header-date-range"
          :class="{
            'ss-salon-dashboard-view-header-date-range--active': $data.$_ssSDV_showPicker
          }"
          @click.stop="$data.$_ssSDV_showPicker = true"
        >
          <div class="ss-salon-dashboard-view-header-date-range__text">
            <span class="ss-salon-dashboard-view-header-date-range__label">
              過去30日間
            </span>
            <span class="ss-salon-dashboard-view-header-date-range__value">
              2026年12月1日〜2026年12月31日
            </span>
          </div>

          <div
            class="ss-salon-dashboard-view-date-range-picker"
            v-show="$data.$_ssSDV_showPicker"
          >
            <div class="ss-salon-dashboard-view-date-range-picker__content">
              <div class="ss-salon-dashboard-view-date-range-picker__presets">
                <div class="ss-salon-dashboard-view-date-range-picker__presets-header">
                  カスタム
                </div>

                <span
                  v-for="(item, index) in $data.$_ssSDV_dateRanges"
                  :key="index"
                  :aria-selected="index === $data.$_ssSDV_selectedDateRangeIndex"
                  class="ss-salon-dashboard-view-date-range-picker__presets-item"
                >
                  {{ item.label }}
                </span>
              </div>

              <div class="ss-salon-dashboard-view-date-range-picker__input">
                <div class="ss-salon-dashboard-view-date-range-picker-range">
                  <div class="ss-salon-dashboard-view-date-range-picker-range__col">
                    開始日

                    <span class="ss-salon-dashboard-view-date-range-picker-range__value">
                    </span>
                  </div>

                  <div class="ss-salon-dashboard-view-date-range-picker-range__col">
                    終了日

                    <span class="ss-salon-dashboard-view-date-range-picker-range__value">
                    </span>
                  </div>
                </div>

                <div>
                  <input type="text" id="ss-salon-dashboard-view__flatpickr" />
                </div>
              </div>
            </div>

            <div class="ss-salon-dashboard-view-date-range-picker__actions">
              <oct-button
                block
                outline
                size="medium"
                @click.native.stop="$data.$_ssSDV_showPicker = false"
              >
                キャンセル
              </oct-button>

              <oct-button
                block
                size="medium"
              >
                OK
              </oct-button>
            </div>
          </div>
        </div>
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OctPrototypeView from '@/mixins/OctPrototypeView.js';
import OctIcon from '@/components/icon/OctIcon.vue'
import OctButton from '@/components/button/OctButton.vue'
import OctMedia from '@/components/media/OctMedia.vue'
import OctTabs from '@/components/tabs/OctTabs.vue'

export default {
  name: 'SSSalonDashboardView',
  mixins: [
    OctPrototypeView
  ],
  components: {
    OctIcon,
    OctButton,
    OctMedia,
    OctTabs,
  },
  data: () => {
    const today = new Date();
    const sevenDaysAgo= new Date();
    const thirtyDaysAgo = new Date();
    const ninetyDaysAgo = new Date();
    const oneHundredEightyDaysAgo = new Date();
    const threeHundredSixtyFiveDaysAgo = new Date();

    const startOfThisWeek = new Date(today);
    startOfThisWeek.setDate(today.getDate() - today.getDay());

    const endOfLastWeek = new Date(startOfThisWeek);
    endOfLastWeek.setDate(startOfThisWeek.getDate() - 1);
    const startOfLastWeek = new Date(endOfLastWeek);
    startOfLastWeek.setDate(endOfLastWeek.getDate() - 6);

    sevenDaysAgo.setDate(today.getDate() - 7);
    thirtyDaysAgo.setDate(today.getDate() - 30);
    ninetyDaysAgo.setDate(today.getDate() - 90);
    oneHundredEightyDaysAgo.setDate(today.getDate() - 180);
    threeHundredSixtyFiveDaysAgo.setDate(today.getDate() - 365);

    function formatDate(date) {
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }

    return {
      $_ssSDV_tabs: [
        {
          text: 'ダッシュボード',
          selected: false,
        },
        {
          text: '顧客一覧',
          selected: false,
        },
      ],
      $_ssSDV_dateRanges: [
        {
          'label': '今週',
          'value': [formatDate(startOfThisWeek), formatDate(today)],
        },
        {
          'label': '先週',
          'value': [formatDate(startOfLastWeek), formatDate(endOfLastWeek)],
        },
        {
          'label': '過去7日間',
          'value': [formatDate(sevenDaysAgo), formatDate(today)],
        },
        {
          'label': '過去30日間',
          'value': [formatDate(thirtyDaysAgo), formatDate(today)],
        },
        {
          'label': '過去90日間',
          'value': [formatDate(ninetyDaysAgo), formatDate(today)],
        },
        {
          'label': '過去180日間',
          'value': [formatDate(oneHundredEightyDaysAgo), formatDate(today)],
        },
        {
          'label': '過去365日間',
          'value': [formatDate(threeHundredSixtyFiveDaysAgo), formatDate(today)],
        },
      ],
      $_ssSDV_selectedDateRangeIndex: 3,
      $_ssSDV_flatpickr: null,
      $_ssSDV_showPicker: false,
    }
  },
  computed: {
    isNotificationRead: vm =>
      !vm.$store.state.staffs.me.notifications.all.length
      || (
        vm.$store.state.staffs.me.data.lastNotificationReadDate &&
        vm.$store.state.staffs.me.data.lastNotificationReadDate.getTime() >=
          vm.$store.state.staffs.me.notifications.all[0].publishedAt.getTime()
      ),
    /** Unread notifications and news */
    unreadNotifications: vm => [...vm.$store.getters['staffs/me/notifications/unread'], ...vm.$store.getters['news/unread']],
    items: vm => vm.$store.getters['treatments/collection']('mine')['items'],
    unsent: vm => vm.$store.getters['treatments/collection']('mine')['items'].filter(item => item.status < 4),
    sent: vm => vm.$store.getters['treatments/collection']('mine')['items'].filter(item => item.status === 4),
    ...mapState({
      me: state => state.staffs.me,
    }),
    newsBanner: () => null
  },
  methods: {
    onClickTab(index) {
      this.$data.$_ssSDV_tabs.forEach(tab => {
        tab.selected = false;
      });
      this.$data.$_ssSDV_tabs[index].selected = true;

      this.$router.push({
        name: index === 0 ? 'SalonDashboard' : 'SalonCustomerList',
        params: {
          salonId: this.$route.params.salonId
        }
      })
    },
    onChangeDateRange(selectedDates, dateStr, instance) {
      console.log(selectedDates, dateStr, instance);
    },
  },
  mounted() {
    if (this.$route.name === 'SalonDashboard') {
      this.$data.$_ssSDV_tabs[0].selected = true;
    } else {
      this.$data.$_ssSDV_tabs[1].selected = true;
    }

    this.$data.$_ssSDV_flatpickr = window.flatpickr('#ss-salon-dashboard-view__flatpickr', {
      mode: 'range',
      locale: 'ja',
      inline: true,
      maxDate: 'today',
      onChange: this.onChangeDateRange,
    });

    this.$data.$_ssSDV_flatpickr.setDate(this.$data.$_ssSDV_dateRanges[this.$data.$_ssSDV_selectedDateRangeIndex].value);
  },
}
</script>

<style scoped lang="scss">
@import "../components/theme/variables";
@import "../components/grid/variables";
@import "../components/typography/variables";
@import "../components/typography/mixins";

.ss-salon-dashboard-view__tabs {
  padding: 0 oct-rem(32);
  border-bottom: oct-rem(1) solid $oct-theme--neutral-20;
}

.ss-salon-dashboard-view__content {
  display: flex;
  flex-direction: column;
  gap: oct-rem(64);
  padding: oct-rem(64);
}

.ss-salon-dashboard-view-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.ss-salon-dashboard-view-header-date-range {
  position: relative;
  display: flex;
  align-items: center;
  gap: oct-rem(8);
  width: oct-rem(382+32);
  height: oct-rem(40);
  padding: 0 oct-rem(16);
  border: oct-rem(1) solid $oct-theme--neutral-20;

  &--active {
    border-color: $oct-theme--neutral;
  }
}

.ss-salon-dashboard-view-header-date-range__text {
  display: flex;
  align-items: center;
  gap: oct-rem(16);
}

.ss-salon-dashboard-view-header-date-range__label {
  font-size: oct-rem(12);
  line-height: 1;
  padding: oct-rem(4);
  background-color: $oct-theme--neutral-10;
}

.ss-salon-dashboard-view-header__title {
  font-size: oct-rem(24);
  font-weight: 600;
  line-height: 1;
  margin: 0;
}

.ss-salon-dashboard-view-date-range-picker {
  position: absolute;
  right: oct-rem(-1);
  top: 100%;
  margin-top: oct-rem(16);
  background-color: $oct-theme--surface;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.10);

  &::v-deep .flatpickr-day.selected,
  &::v-deep .flatpickr-day.startRange {
    background-color: $oct-theme--primary;
  }

  &::v-deep .flatpickr-calendar {
    box-shadow: none !important;
  }
}

.ss-salon-dashboard-view-date-range-picker__content {
  display: flex;
  padding: oct-rem(32) oct-rem(32) oct-rem(64);
}

.ss-salon-dashboard-view-date-range-picker__presets {
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);
  width: oct-rem(144+32);
  height: 100%;
  padding-right: oct-rem(32);
}

.ss-salon-dashboard-view-date-range-picker__presets-header {
  font-size: oct-rem(14);
  line-height: 1;
  padding-bottom: oct-rem(16);
  border-bottom: oct-rem(1) solid $oct-theme--neutral-20;
}

.ss-salon-dashboard-view-date-range-picker__presets-item {
  font-size: oct-rem(14);
  line-height: 1;
  display: block;
  cursor: pointer;

  &:hover, &[aria-selected="true"] {
    font-weight: 600;
    color: $oct-theme--primary;
  }
}

.ss-salon-dashboard-view-date-range-picker__input {
  display: flex;
  flex-direction: column;
  gap: oct-rem(32);
  padding-left: oct-rem(32);
  border-left: oct-rem(1) solid $oct-theme--neutral-20;
}

.ss-salon-dashboard-view-date-range-picker-range {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: oct-rem(24);
}

.ss-salon-dashboard-view-date-range-picker-range__col {
  font-size: oct-rem(12);
  line-height: 1;
  display: flex;
  flex-direction: column;
  gap: oct-rem(8);
}

.ss-salon-dashboard-view-date-range-picker-range__value {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: oct-rem(40);
  border: oct-rem(1) solid $oct-theme--neutral-20;
}

#ss-salon-dashboard-view__flatpickr {
  display: none;
}

.ss-salon-dashboard-view-date-range-picker__actions {
  display: flex;
  justify-content: flex-end;
  gap: oct-rem(16);
  padding: oct-rem(32);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.10);

  .oct-button {
    width: oct-rem(80+48);
  }
}

.ss-dashboard-header {
  position: sticky;
  top: 0;
  margin-bottom: oct-rem(32);
  background-color: $oct-theme--surface;
  z-index: 2;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(64);
}
}

.ss-dashboard-header__content {
  position: relative;
  display: flex;
  align-items: center;
  height: oct-rem(80);
  padding: oct-rem(16);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  height: oct-rem(120);
  padding: oct-rem(32);
}
}

.ss-dashboard-header__graphic {
  margin-right: oct-rem(76-48);
  flex: 0 0 oct-rem(48);
  max-width: oct-rem(48);
  width: oct-rem(48);
  height: oct-rem(48);
  border: 1px solid $oct-theme--neutral-20;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-right: oct-rem(144-56);
  flex: 0 0 oct-rem(56);
  max-width: oct-rem(56);
  width: oct-rem(56);
  height: oct-rem(56);
}
}

.ss-dashboard-header__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ss-dashboard-header__title {
  flex: 1 1 auto;
  text-align: center;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(20);
}
}

.ss-dashboard__content {
  margin: 0 auto;
  padding: 0 oct-rem(16);

  &--empty {
    text-align: center;
    position: fixed;
    top: 80px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 80px - 92px);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  max-width: oct-rem(1312+64*2);
  margin-bottom: oct-rem(108-32-64);
  padding: 0 oct-rem(64);

  &:not(.ss-dashboard__content--empty) {
    display: grid;
    column-gap: oct-rem(32);
    grid-template-columns: 1fr 1fr;
  }

  &--empty {
    position: static;
  }

  &::v-deep .oct-list-item__graphic {
    margin-right: oct-rem(20);
    flex: 0 0 oct-rem(80);
    width: oct-rem(80);
    max-width: oct-rem(80);
    height: oct-rem(80);
  }

  &::v-deep .oct-list-item__primary-text {
    font-size: oct-rem(24);

    .oct-list-item--single & {
      font-size: oct-rem(20);
    }
  }

  &::v-deep .oct-list-item__text-line {
    margin-bottom: oct-rem(6);
  }

  &::v-deep .oct-list-item__secondary-text,
  &::v-deep .oct-list-item__caption-text {
    font-size: oct-rem(14);
  }

  &::v-deep .oct-list-item__caption-text {
    margin-top: oct-rem(6);
  }
}
}

.ss-dashboard__list {
  &--empty {
    display: none;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  &--empty {
    display: block;
  }
}
}

.ss-dashboard__list-item-meta {
  margin: 0 oct-rem(16) 0 0;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  gap: oct-rem(8);

  .oct-icon {
    fill: $oct-theme--neutral-30;
    width: oct-rem(16);
    height: oct-rem(16);
  }

  &::v-deep .oct-icon--active {
    fill: $oct-theme--danger;
  }
}

.ss-dashboard-note {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: oct-rem(16);
}

.ss-dashboard-note__primary-text {
  font-size: oct-rem(24);
  line-height: (36/24);
  display: block;
}

.ss-dashboard-note__secondary-text {
  font-size: oct-rem(20);
  line-height: 1;
  display: block;
}

.ss-dashboard-header__actions {
  position: relative;
  flex: 0 0 auto;
  gap: oct-rem(12);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: $oct-theme--surface;
  z-index: 2;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  gap: oct-rem(24);
}
}

.ss-dashboard-header__action {
  width: oct-rem(32);
  height: oct-rem(32);
  cursor: pointer;

  &--exit {
    display: none;
  }

  .oct-icon {
    fill: $oct-theme--neutral;
    width: 100%;
    height: 100%;
  }

  &--activated {
    position: relative;

    .oct-icon {
      fill: $oct-theme--primary;
    }

    &:after {
      content: "";
      position: absolute;
      top: oct-rem(-2);
      right: oct-rem(-2);
      width: oct-rem(12);
      height: oct-rem(12);
      background-color: $oct-theme--neutral-30;
      border: oct-rem(2) solid $oct-theme--surface;
      border-radius: 50%;
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  &--exit {
    display: block;
  }
}
}

</style>